export default __webpack_public_path__ + "locales/ro/Files.json?hash=8f1df57eb320c3fdf26d0c284f6a0b9d";